import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = sameValueForEveryLocale("/");

export function getHomepagePath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
